<section class="faq-card rounded-large" data-testid="cms-ond-faqs">
  @let faqTitle = title();
  @if (faqTitle) {
    <h2
      class="faq-title nordic-blue-900-text text-icon-primary font-heading-2 font-headline-small mr-clear-t mr-large-b"
    >
      {{ faqTitle }}
    </h2>
  }

  @for (faq of faqs(); track faq.contentId; let last = $last) {
    <div class="faq-item" [class.mr-large-b]="!last" data-testid="cms-ond-faqs-item">
      <div class="faq-row">
        <fcom-icon
          class="faq-icon icon-medium nordic-blue-900-text text-icon-primary"
          [name]="SvgLibraryIcon.SINGLE_PAX"
        />
        <h3
          class="faq-question nordic-blue-900-text text-icon-primary font-body-1 medium-type font-label-medium mr-clear-y"
          data-testid="cms-ond-faqs-question"
        >
          {{ faq.teaserTitle }}
        </h3>
      </div>
      <div class="faq-row mr-xsmall-t">
        <fcom-icon
          class="faq-icon icon-medium nordic-blue-900-text text-icon-primary"
          [name]="SvgLibraryIcon.FINNAIR_EMBLEM"
        />
        <div
          class="faq-answer nordic-blue-900-text text-icon-primary font-body-1 font-body-medium"
          data-testid="cms-ond-faqs-answer"
          [innerHTML]="faq.teaserText"
        ></div>
      </div>
    </div>
  }
</section>
